module.formDirective('enrollmentEndFormOld', function() {
    return {
        modelName: 'student',
        subModel: 'duration_of_stay',
        formName: 'enrollment_end',
        templateDirectory: 'students/enrollment',
        scope: {
            next: '=',
            previous: '=',
        },
        copyData: function(scope) {
            return {
                exit_reason: angular.copy(scope.model.duration_exit_reason),
                duration_end: angular.copy(scope.model.duration_end),
                participant_email: angular.copy(scope.rootModel.participant_email),
                exit_description: angular.copy(scope.model.exit_description),
            };
        },
        allowDelete: function(scope) {
            return !!scope.model.duration_end;
        },
        delete: function(model, scope) {
            return model.$saveForm('remove_exit', {});
        }
    };
});

module.directive('enrollmentEndForm', function(ModelService) {
    var fields = ['duration_exit_reason', 'duration_end', 'exit_description'];
    return {
        restrict: 'E',
        templateUrl: 'students/enrollment/enrollmentEndForm',
        scope: {duration: '=', next: '=', previous: '='},
        require: '^basicForm',
        link: function(scope, element, attrs, basicForm) {
            scope.data = basicForm.data = ModelService.copyFields(scope.duration, fields);
            scope.form = basicForm.getForm();

            basicForm.save = function(data) {
                return ModelService.patchModel(scope.duration, data);
            };

            basicForm.setDeleteFunctions(function() {
                return ModelService.patchModel(scope.duration, {
                    duration_end: null,
                });
            }, function() {
                return !!scope.duration.duration_end;
            });
        },
    };
});


module.formDirective('enrollmentReenrollForm2', function() {
    return {
        modelName: 'student',
        subModel: 'duration_of_stay',
        templateDirectory: 'students/enrollment',
        scope: {previous: '='},
        copyData: function() {
            return {};
        },
        save: function(student, duration, data) {
            return student.$create('duration_of_stay', data);
        },
    };
});


module.directive('enrollmentReenrollForm', function(ModelService) {
    return {
        restrict: 'E',
        templateUrl: 'students/enrollment/enrollmentReenrollForm',
        scope: {previous: '=', enrollment: '='},
        require: '^basicForm',
        link: function(scope, element, attrs, basicForm) {
            scope.data = basicForm.data = {};
            scope.form = basicForm.getForm();

            basicForm.save = function(data) {
                ModelService.postModelRelation(scope.enrollment, 'durations', data);
            };
        }
    }
})